'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image'; // ALLOW-RAW-IMG: static OAuth brand marks copied from mobile; no user content or preview.
import { ProviderIcon } from '@/components/settings/provider-icon';
import { cn } from '@/lib/ui/utils';
interface SocialProviderIconProps {
  provider: string;
  className?: string | undefined;
}
const SOCIAL_PROVIDER_ICON_SRC: Readonly<Record<'apple' | 'google' | 'x', string>> = {
  apple: '/icons/social-providers/apple-logo.svg',
  google: '/icons/social-providers/google-logo.svg',
  x: '/icons/social-providers/x-logo.svg'
};

/** Exact 24px brand artwork shared with mobile's intro authentication buttons. */
export function SocialProviderIcon(t0) {
  const $ = _c(9);
  const {
    provider,
    className
  } = t0;
  if (provider !== "apple" && provider !== "google" && provider !== "x") {
    let t1;
    if ($[0] !== className || $[1] !== provider) {
      t1 = className === undefined ? <ProviderIcon provider={provider} /> : <ProviderIcon provider={provider} className={className} />;
      $[0] = className;
      $[1] = provider;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  const t1 = SOCIAL_PROVIDER_ICON_SRC[provider];
  let t2;
  if ($[3] !== className) {
    t2 = cn("brightness-0 dark:invert", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `social-provider-icon-${provider}`;
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <Image src={t1} alt="" width={24} height={24} className={t2} aria-hidden="true" data-testid={t3} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}